import type { App } from 'vue';

import Popover from './Popover.vue';
import Tooltip from './Tooltip.vue';
import emitter from '@/emitter';
import type { App } from 'vue';

/**
 *
 */
class TypeBinding {
  public arg: any;
  public modifiers: any;
  public value: any;
}

const defaultPosition = 'bottom';

/**
 * prepareBinding
 * @param root0 ..
 * @param root0.arg ..
 * @param root0.modifiers ..
 * @param root0.value ..
 * @returns ..
 */
const prepareBinding = ({ arg, modifiers, value }: TypeBinding) => {
  const mods = Object.keys(modifiers);
  const name = typeof value === 'object' && value.name ? value.name : arg;
  const position = mods[0] || value.position || defaultPosition;

  return { name, position, value };
};

/**
 * addClickEventListener
 * @param target ..
 * @param params ..
 */
const addClickEventListener = (target: any, params: any) => {
  /**
   * click
   * @param srcEvent ...
   */
  const click = (srcEvent: any) => {
    emitter.emit('show:click', { ...params, target, srcEvent });

    /**
     * handler
     * @param srcEvent ..
     */
    const handler = (srcEvent: any) => {
      emitter.emit('hide:click', { ...params, target, srcEvent });
      document.removeEventListener('click', handler);
    };

    document.addEventListener('click', handler);
    srcEvent.stopPropagation();
  };

  target.addEventListener('click', click);

  /**
   * anonymous function
   */
  target.$popoverRemoveClickHandlers = () => {
    target.removeEventListener('click', click);
  };
};

/**
 * addHoverEventListener
 * @param target ..
 * @param params ..
 */
const addHoverEventListener = (target: any, params: any) => {
  /**
   * mouseenter
   * @param srcEvent ..
   */
  const mouseenter = (srcEvent: any) => {
    emitter.emit('show:hover', { ...params, target, srcEvent });
  };

  /**
   * mouseleave
   * @param srcEvent ..
   */
  const mouseleave = (srcEvent: any) => {
    emitter.emit('hide:hover', { ...params, target, srcEvent });
  };

  target.addEventListener('mouseenter', mouseenter);
  target.addEventListener('mouseleave', mouseleave);

  /**
   * anonymous function
   */
  target.$popoverRemoveHoverHandlers = () => {
    target.removeEventListener('mouseenter', mouseenter);
    target.removeEventListener('mouseleave', mouseleave);
  };
};

export default {
  /**
   * install
   * @param app ..
   * @param params ..
   */
  install(app: App, params: any = {}) {
    document.addEventListener('resize', (event) => {
      emitter.emit('hide', { srcEvent: event });
    });

    app.component('Popover', Popover);

    app.directive('popover', {
      /**
       * bind
       * @param target ..
       * @param binding ..
       */
      beforeMount: function (target: any, binding: any) {
        const params = prepareBinding(binding);
        addClickEventListener(target, params);
        addHoverEventListener(target, params);
      },
      // eslint-disable-next-line no-unused-vars
      /**
       * unbind
       * @param target ..
       * @param binding ..
       */
      unmounted: function (target: any, binding: any) {
        target.$popoverRemoveHoverHandlers();
        target.$popoverRemoveClickHandlers();
      },
    });

    if (params.tooltip) {
      if (params.debug) {
        // eslint-disable-next-line no-console
        console.log('vue-js-popover | tooltip active');
      }
      app.component('Tooltip', Tooltip);
    }
  },
};
